import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import { logger } from '@/utils/logger'

import { ApiSample } from '~/endpoints/ApiSample'
import { ApiSamples } from '~/endpoints/ApiSamples'

// State types
interface StateSample {
  parameterA: number
  parameterB: number
}

interface StateSamplesNode {
  id: number
  parameterA: number
  parameterB: number
}
type StateSamples = StateSamplesNode[]

// State action parameter

interface ActionParamsRefleshSample {
  paramA: number
  paramB: number
}

interface ActionParamsSetSample {
  parameterA: number
  parameterB: number
}

interface ActionParamsRefleshSamples {
  paramA: number
  paramB: number
}
interface ActionParamsSetSamples {
  id: number
  parameterA: number
  parameterB: number
}

@Module({
  stateFactory: true,
  namespaced: true,
  name: 'apis/Sample',
})
export default class Sample extends VuexModule {
  // States

  // Sample
  private sample_: StateSample = {
    parameterA: 0,
    parameterB: 0,
  }

  // Samples
  private samples_: StateSamples = []

  // Getters

  // sample
  get sample(): StateSample {
    return this.sample_
  }

  // samples
  get samples(): StateSamples {
    return this.samples_
  }

  // Mutations

  @Mutation
  updateSample(value: StateSample) {
    this.sample_ = value
  }

  @Mutation
  updateSamples(values: StateSamples) {
    this.samples_ = values
  }

  @Mutation
  updateSamplesNode(value: StateSamplesNode) {
    if (this.samples_.find(elem => elem.id === value.id)) {
      this.samples_ = this.samples_.map(elem => (elem.id === value.id ? value : elem))
    } else {
      this.samples_.push(value)
    }
  }

  // Actions

  @Action
  clear() {
    this.context.commit(
      'updateSample',
      ((): StateSample => ({
        parameterA: 0,
        parameterB: 0,
      }))()
    )
    this.context.commit('updateSamples', [])
  }

  @Action
  async refreshSample(param: ActionParamsRefleshSample) {
    logger.trace('in: refreshSample')
    const api = new ApiSample.Api()

    // API: Sample
    const result = await api.get<StateSample | null>(
      {
        query: {
          paramA: param.paramA,
          paramB: param.paramB,
        },
      },
      // success
      (data, _) => {
        return {
          parameterA: data.parameterA,
          parameterB: data.parameterB,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSample', result)
  }

  @Action
  async setSample(param: ActionParamsSetSample) {
    logger.trace('in: setSample')
    const api = new ApiSample.Api()

    // API: Sample
    const result = await api.post<StateSample | null>(
      {
        body: {
          parameterA: param.parameterA,
          parameterB: param.parameterB,
        },
      },
      // success
      (data, _) => {
        return {
          parameterA: data.parameterA,
          parameterB: data.parameterB,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSample', result)
  }

  @Action
  async refreshSamples(param: ActionParamsRefleshSamples) {
    logger.trace('in: refreshSamples')
    const api = new ApiSamples.Api()

    // API: Sample
    const result = await api.get<StateSamples | null>(
      {
        query: {
          paramA: param.paramA,
          paramB: param.paramB,
        },
      },
      // success
      (data, _) => {
        return data.map(
          (elem): StateSamplesNode => ({
            id: elem.id,
            parameterA: elem.parameterA,
            parameterB: elem.parameterB,
          })
        )
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSamples', result)
  }

  @Action
  async setSamples(param: ActionParamsSetSamples) {
    logger.trace('in: setSamples')
    const api = new ApiSamples.Api()

    // API: Sample
    const result = await api.post<StateSamplesNode | null>(
      {
        path: {
          id: param.id,
        },
        body: {
          parameterA: param.parameterA,
          parameterB: param.parameterB,
        },
      },
      // success
      (data, _) => {
        return {
          id: data.id,
          parameterA: data.parameterA,
          parameterB: data.parameterB,
        }
      },
      // Error
      (data, status) => {
        logger.error(status, data)
        return null
      }
    )
    if (result === null) {
      return
    }
    this.context.commit('updateSamplesNode', result)
  }
}
